import { Navigate, Outlet, useLocation } from "react-router";
import { useAuth } from "@client/hooks/use-auth";
import { PageLoader } from "@client/components/ui/PageLoader";

/** Sends anonymous visitors to /login, remembering where they were going. */
export function RequireAuth() {
  const { status } = useAuth();
  const location = useLocation();

  if (status === "loading") return <PageLoader />;
  if (status === "anonymous") {
    const redirect = `${location.pathname}${location.search}`;
    return <Navigate to={`/login?redirect=${encodeURIComponent(redirect)}`} replace />;
  }
  return <Outlet />;
}

/** UI gate only — every /api/admin route is enforced by the server independently. */
export function RequireAdmin() {
  const { status, user } = useAuth();
  if (status === "loading") return <PageLoader />;
  if (!user?.isAdmin) return <Navigate to="/" replace />;
  return <Outlet />;
}
